import request from "@/providers/requests";
import axios from "@/providers/requests";
import ENDPOINTS from "@/providers/end-points";
import { OrderInterface } from "@/interface/order.inteface";
import { Order, Orders } from "@/modules/orders/";
import { Response } from "@/interface/response.interface";
import { OrderType } from "@/types/orders";
import { CustomerTransaction } from "@/modules/customer/transactions/transaction";
import OrderManagement from "@/modules/orders/management";
import { OrdersInterface } from "@/interface/business/order.interface";
import CounterBack4App from "@/services/counter-back4app";
import { Translate as $t } from "@/plugins/translate";
import CardsOrders from "@/modules/orders/cards";
import OrderCardSummary from "@/modules/orders/card";
import { Helper } from "@/services/helper";

export default {
  namespaced: true,

  state: () => ({
    success: false,
    message: null,
    count: 0,
    orders: [],
    customerOrders: [],
    countList: 0,
    ordersCount: 0,
    ordersList: [],
    order: null,
    orderDetails: null,
    response: null,
    isOrderSaved: false,
    transaction: null,
    orderNumber: null,
    orderHistoryDetails: null,
    createOrderFromPath: null,
    orderManagementDetails: null,
    orderLocationsList: [],
    orderList: [],
    orderListCount: 0,
    isCompletedExceedLimit: false,
    isOrdersListExceedLimit: false,
    ordersListMeta: null,
  }),

  getters: {
    count: (state: any): Number => state.count,
    countList: (state: any): Number => state.countList,
    order: (state: any): OrderInterface => state.order,
    orders: (state: any): OrdersInterface => state.orders,
    customerOrders: (state: any): OrdersInterface => state.customerOrders,
    ordersList: (state: any): OrdersInterface => state.ordersList,
    response: (state: any): Array<any> => state.response,
    isOrderSaved: (state: any): Array<any> => state.isOrderSaved,
    transaction: (state: any): any => state.transaction,
    OrderNumber: (state: any): any => state.orderNumber,
    OrderDetails: (state: any): any => state.orderDetails,
    OrderHistoryDetails: (state: any): any => state.orderHistoryDetails,
    CreateOrderFromPath: (state: any): any => state.createOrderFromPath,
    OrderManagementDetails: (state: any): any => state.orderManagementDetails,
    OrderLocationsList: (state: any): any => state.orderLocationsList,
    OrdersCount: (state: any): any => state.ordersCount,
    OrderList: (state: any): any => state.orderList,
    OrderListCount: (state: any): any => Helper.formatNumberWithComma(state.orderListCount || 0),
    IsCompletedExceedLimit: (state: any): boolean => state.isCompletedExceedLimit,
    IsOrdersListExceedLimit: (state: any): boolean => state.isOrdersListExceedLimit,
    OrdersListMeta: (state: any): boolean => state.ordersListMeta,
    ResponseStatus: (state: any): any => ({
      success: state.success,
      message: state.message,
    }),
  },

  mutations: {
    SET_RESPONSE_STATUS(state: any, payload: any) {
      state.message = payload?.message || null;
      state.success = payload?.success || false;
    },

    SET_IS_COMPLETED_ORDERS_EXCEED_LIMIT(state: any, boolean: boolean = false) {
      state.isCompletedExceedLimit = boolean;
    },

    SET_IS_ORDERS_LIST_LIMIT(state: any, boolean: boolean = false) {
      state.isOrdersListExceedLimit = boolean;
    },

    SET_ORDERS_LIST(state: any, payload: any) {
      state.orders = payload?.orders;
      state.orderListCount = payload?.count;
    },

    SET_CUSTOMER_ORDERS_LIST(state: any, payload: any) {
      state.customerOrders = payload;
    },

    SET_ORDERS_BY_STATUS_LIST(state: any, payload: any) {
      state.ordersList = payload?.orders;
      state.countList = payload?.count || 0;
    },

    SET_ORDERS_COUNTER(state: any, count: number) {
      state.ordersCount = count;
    },

    SET_CARDS_ORDERS_LIST(state: any, { orders, count, isReset = false, meta = null }) {
      if (isReset) {
        state.orderList = [];
        state.orderListCount = 0;
        state.ordersListMeta = null;
        return;
      }
      state.orderList = [...state.orderList, ...orders];
      state.orderListCount = count;
      state.ordersListMeta = meta;
    },

    SET_ORDER_LIST_COUNT(state: any, { count, action = "reset" }) {
      if (action === "RESET") {
        return (state.orderListCount = count);
      }
      state.orderListCount += count || 0;
    },

    SET_ORDERS_COUNT_LIST(state: any, countList: number) {
      state.countList = countList;
    },

    SET_ORDER(state: any, payload: any = null) {
      state.order = payload ? new Order(payload) : null;
    },

    SET_ORDER_TRANSACTION(state: any, payload: any) {
      state.transaction = payload;
    },

    UPDATE_ORDER_TOTALS(state: any, payload: any) {
      state.order.updateTotals(payload);
    },

    SET_RESPONSE(state: any, payload: any) {
      state.response = payload;
    },

    SET_IS_ORDER_SUCCESS(state: any, payload: boolean) {
      state.isOrderSaved = payload;
    },

    SET_ORDER_NUMBER(state: any, payload: number = 0) {
      state.orderNumber = payload;
    },

    SET_ORDER_DETAILS_SUMMARY(state: any, payload: any) {
      state.orderDetails = payload;
    },

    SET_ORDER_HISTORY_DETAILS(state: any, payload: any) {
      state.orderHistoryDetails = new Order(payload);
    },

    SET_CREATE_ORDER_FROM_PATH(state: any, payload: any) {
      state.createOrderFromPath = payload;
    },

    SET_ORDER_MANAGEMENT_DETAILS(state: any, payload: any) {
      state.orderManagementDetails = payload;
    },

    SET_ORDER_LOCATIONS_LIST(state: any, locations: Array<any> = []) {
      state.orderLocationsList = locations;
    },
  },

  actions: {
    async getOrdersManagements({ commit }: { commit: any }, payload) {
      return await request
        .get(`${ENDPOINTS.TABS(payload)}`)
        .then((response) => response.data)
        .then(async ({ data, count }) => {
          // summarization list
          const orders = data.map((order) => new OrderManagement(order));
          // commit list
          await commit("SET_ORDERS_LIST", { orders, count });
          await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message });
        })
        .catch(async ({ error }) => {
          await commit("SET_ORDERS_LIST", null);
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
          console.log(error);
        });
    },

    async getOrders({ state, commit }: { state: any; commit: any }, payload) {
      return await request
        .get(`${ENDPOINTS.TABS(payload)}`)
        .then((response) => response.data)
        .then(async ({ data, count, meta }) => {
          // summarization list
          const orders = new CardsOrders(data, count, meta);

          if (payload?.isHistory) {
            // commit list
            await commit("SET_ORDERS_LIST", { orders, count });
          } else {
            // cards list
            await commit("SET_CARDS_ORDERS_LIST", {
              orders: orders?.list,
              count,
              meta: orders.meta.cardsCounts,
            });
          }

          await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message });
          await commit("SET_IS_ORDERS_LIST_LIMIT", data.length < payload?.page_size);
        })
        .catch(async ({ error, ...reset }) => {
          await commit("SET_ORDERS_LIST", { orders: null, count: 0 });
          await commit("SET_CARDS_ORDERS_LIST", { orders: null, count: 0 });
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
          await commit("SET_IS_ORDERS_LIST_LIMIT", false);
        });
    },

    async getCustomerOrders({ commit }: { commit: any }, payload) {
      return await request
        .get(`${ENDPOINTS.TABS(payload)}`)
        .then((response) => response.data)
        .then(async ({ data, count, meta }) => {
          // summarization list
          const orders = new Orders(data, count, meta);

          // commit list
          await commit("SET_CUSTOMER_ORDERS_LIST", { ...orders, count });
          await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message });
        })
        .catch(async ({ error }) => {
          await commit("SET_CUSTOMER_ORDERS_LIST", { orders: null, count: 0 });
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
        });
    },

    async getOrdersByStatus({ state, commit }: { state: any; commit: any }, payload) {
      return await request
        .get(`${ENDPOINTS.TABS(payload)}`)
        .then((response) => response.data)
        .then(async ({ data, count, meta }) => {
          // summarization list
          const orders = new CardsOrders(data, count, {
            ...meta,
            isClosed: true,
          });

          let orderListCount = state.orderListCount;
          if (payload.page === 1) {
            orderListCount = count + state.orderListCount;
          }

          const newMeta = {
            ...state.ordersListMeta,
            ...orders.meta.cardsCounts,
          };

          await commit("SET_CARDS_ORDERS_LIST", {
            orders: orders?.list,
            count: orderListCount,
            meta: newMeta,
          });
          await commit("SET_RESPONSE_STATUS", { success: true, message: data?.message });
          await commit("SET_IS_COMPLETED_ORDERS_EXCEED_LIMIT", data.length < payload?.page_size);
        })
        .catch(async ({ error }) => {
          await commit("SET_ORDERS_BY_STATUS_LIST", null);
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });

          await commit("SET_IS_COMPLETED_ORDERS_EXCEED_LIMIT", false);
          await commit("SET_CARDS_ORDERS_LIST", {
            orders: [],
            count: 0,
          });
          console.log(error);
        });
    },

    async getOrderListById({ commit }: { commit: any }, { location_id, tab_id }) {
      return await request
        .get(`${ENDPOINTS.TAB(location_id, tab_id)}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          // summarization order
          const order = new OrderCardSummary(data);
          // commit order as summary
          await commit("SET_ORDER_DETAILS_SUMMARY", order);
        })
        .catch(async (error) => {
          await commit("SET_ORDER_DETAILS_SUMMARY", null);
          console.log(error);
        });
    },

    async getOrderSummaryById({ commit }: { commit: any }, { location_id, tab_id }) {
      return await request
        .get(`${ENDPOINTS.TAB(location_id, tab_id)}`)
        .then((response) => response.data)
        .then(async ({ data }) => {
          const order = new OrderManagement(data);
          await commit("SET_ORDER_MANAGEMENT_DETAILS", order);
        })
        .catch(async (error) => {
          await commit("SET_ORDER_MANAGEMENT_DETAILS", null);
          console.log(error);
        });
    },

    async getOrder({ commit }: { commit: any }, payload) {
      return await request
        .get<Response<OrderType>>(ENDPOINTS.TAB(payload.location_id, payload.tab_id))
        .then((response) => response.data)
        .then(async ({ data }) => {
          return await commit("SET_ORDER", data);
        })
        .catch(async (error) => {
          console.log(error);
          await commit("SET_ORDER", null);
        });
    },

    async getOrderHistory({ commit }: { commit: any }, payload) {
      return await request
        .get<Response<OrderType>>(ENDPOINTS.TAB(payload.location_id, payload.tab_id))
        .then((response) => response.data)
        .then(async ({ data }) => {
          return await commit("SET_ORDER_HISTORY_DETAILS", data);
        })
        .catch(async (error) => {
          await commit("SET_ORDER_HISTORY_DETAILS", null);
          console.log(error);
        });
    },

    async getTotals({ state, commit }) {
      // get the calculate tab object
      const payload = state.order?.toTab();
      if (!payload) return;
      return await request
        .post<Response<Array<any>>>(ENDPOINTS.CALCULATOR_TAB, payload)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("UPDATE_ORDER_TOTALS", data);
          await commit("SET_RESPONSE_STATUS", { success: true, message: "" });
        })
        .catch(async ({ error }) => {
          await commit("UPDATE_ORDER_TOTALS", null);
          await commit("SET_RESPONSE_STATUS", {
            success: false,
            message: error?.message || $t("something_went_wrong"),
          });
          console.log(error);
        });
    },

    async storeOrder({ state, commit, dispatch }, order) {
      const payload = order.toCreateTab();
      await commit("SET_RESPONSE", null);
      return await request
        .post<Response<OrderType>>(ENDPOINTS.STORE_TAB(payload?.location_id || ""), payload)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_RESPONSE", data);
          await commit("SET_IS_ORDER_SUCCESS", !!data?.id);
          order.isFailed = false;
        })
        .catch(async (error) => {
          if (error.code >= 500) {
            await order.storeFailedOrder();
          }

          await commit("SET_IS_ORDER_SUCCESS", false);
          await commit("SET_RESPONSE", null);
          await commit("SET_IS_ORDER_SUCCESS", false);
        });
    },

    async updateOrder({ state, commit }, payload) {
      const body = payload.order.toCreateTab();
      await commit("SET_RESPONSE", null);
      return await request
        .put<Response<OrderType>>(ENDPOINTS.TAB(payload.location_id, payload.tab_id), body)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_RESPONSE", data);
          await commit("SET_IS_ORDER_SUCCESS", !!data?.id);
          payload.order.isFailed = false;
        })
        .catch(async (error) => {
          await commit("SET_IS_ORDER_SUCCESS", false);
          console.log(error, payload.order);
        });
    },

    async updateOrderStatus({ state, commit }, payload) {
      await commit("SET_RESPONSE", null);
      return await request
        .patch<Response<OrderType>>(ENDPOINTS.TAB(payload.location_id, payload.tab_id), payload.body)
        .then((response) => response.data)
        .then(async ({ data }) => {
          await commit("SET_IS_ORDER_SUCCESS", !!data?.id);
        })
        .catch(async (error) => {
          await commit("SET_IS_ORDER_SUCCESS", false);
          console.log(error, payload.order);
        });
    },

    //TODO:
    // Prepare the transaction api from the BE Team
    async getOrderTransaction({ commit }: { commit: any }, location_id: string) {
      return await request
        .get(`${ENDPOINTS.TABS({ location_id })}`)
        .then((response) => response.data)
        .then(async ({ data, count, meta }) => {
          const orders = new Orders(data, count, meta);
          await commit("SET_ORDERS_LIST", { orders, count });
        })
        .catch(async (error) => {
          await commit("SET_ORDERS_LIST", null);
          console.log(error);
        });
    },

    async getTransaction({ commit }: { commit: any }, id) {
      return await axios
        .get(ENDPOINTS.SALE(id))
        .then((response) => response.data)
        .then(async ({ data }) => {
          const transaction = new CustomerTransaction(data);
          await commit("SET_ORDER_TRANSACTION", transaction);
        })
        .catch(async (error) => {
          await commit("SET_ORDER_TRANSACTION", null);
          await console.log(error);
        });
    },

    async getTransactionDetails({ commit }: { commit: any }, { location_id, tab_id }) {
      return await axios
        .get(ENDPOINTS.TRANSACTION_DETAILS({ location_id, tab_id }))
        .then((response) => response.data)
        .then(async ({ data }) => {
          const transaction = new CustomerTransaction(data[0]);
          await commit("SET_ORDER_TRANSACTION", transaction);
        })
        .catch(async (error) => {
          await commit("SET_ORDER_TRANSACTION", null);
          await console.log(error);
        });
    },

    async getOrderNumber({ commit }: { commit: any }) {
      const OrderCounterB4App = new CounterBack4App();
      await OrderCounterB4App.setCounter();
      OrderCounterB4App.unSubscribe();
      await commit("SET_ORDER_NUMBER", OrderCounterB4App.counter);

      // Old Code
      // return await axios
      //   .get(ENDPOINTS.TAB_COUNTER)
      //   .then((response) => response.data)
      //   .then(async ({ data }) => {
      //     await commit("SET_ORDER_NUMBER", data?.counter || 0);
      //   })
      //   .catch(async (error) => {
      //     debugger;
      //     await console.log(error);
      //   });
    },

    async setOrderLocationsList({ commit }: { commit: any }, locations: Array<any> = []) {
      await commit("SET_ORDER_LOCATIONS_LIST", locations);
    },
  },
};
